<template>
  <div class="nx-signing-modal-method-p12">
    <div v-if="loginState !== 'success'">
      <div v-if="loginState === 'checking'">
        <h4>{{ $t('CheckIAMSmart') }}</h4>

        <p class="mt-4">
          <b-spinner class="m-auto" />
        </p>
      </div>
      <div v-else-if="loginState === 'fail'">
        <h4>{{ $t('FailGetIAMSmart') }}</h4> 
        <p class="mt-4">
          <IAMSmartLoginButton class="m-auto" @click="loginState = 'retry'" />
        </p>
        <IAMSmartLink
          style="center;text-decoration:underline"
        />   
      </div>
      <div v-else-if="loginState === 'retry'">
        <h4>{{$t('RefreshAfterIAMSmartLogin')}}</h4>

        <p class="mt-4">
          <b-button class="m-auto" @click="acquireAccessToken">{{$t('Retry')}}</b-button>
        </p>
      </div>
    </div>

    <div v-else>
      <h4>{{$t('PrepareAccount')}}</h4>
      <p>
        <span class="instruct-label" v-text="$t('serviceNameLabel')" />
        {{ $t('serviceName') }}
      </p>
      <p class="mt-4" v-if="!show">
        <IAMSmartSigningPlainButton :disabled="!canSign" style="margin: auto;" @click="batchSign">{{$t('StartSigning')}}</IAMSmartSigningPlainButton>     
      </p>
      <!-- <p class="mt-2" v-if="!canSign">{{$t('IamSmartReminder')}}<a :href="iAMSmartPlusUrl" target="_blank" style="text-decoration:underline" v-if="!canSign">{{$t('IamSmartWebSite')}}</a></p> -->
      <p class="mt-2" v-if="!canSign">{{$t('IamSmartReminder')}}<a @click="goToIamSmartWebsite()" target="_blank" style="text-decoration:underline" v-if="!canSign">{{$t('IamSmartWebSite')}}</a></p>
      <p class="mt-1"><IAMSmartLink style="text-decoration:underline"/></p>
      <b-table-simple>
        <b-thead> 
          <b-tr>
            <b-th>{{$t('DocumentName')}}</b-th>
            <b-th>{{$t('IdentificationCode')}}</b-th>
            <b-th>{{$t('Signstatus')}}</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="file of files" :key="file.id">
            <b-td>{{ file.name }}</b-td>
            <b-td class="signCode">{{ file.signCode || '-' }}</b-td>
            <b-td v-bind:class="[file.status === 'Signed' ? { 'signCode': true } : file.status === 'Failed' ? { 'signFailed': true } : {} ]">{{ $t('status.' + file.status) }}</b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <b-container v-if="canSign" class="text-left">
        <p
          class="instruct-label"
          v-text="$t('tempIamSmartInstrHeader')"
        />
        <ol class="instruct-list">
          <li>
            <div class="signCode">
              {{ $t('iamSmart.signingDesktop.instructStep1') }}
            </div>
            <b-img
              v-if= "!isMobile"
              style="height: 100px"
              :src="
                require('@nextore/iam-smart/dist/assets/iamsmart/tapToOpen/tap.png')
              "
            />
          </li>
          <li>{{ $t('iamSmart.signingDesktop.instructStep2') }}</li>
          <li>{{ $t('iamSmart.signingDesktop.instructStep3') }}</li>
        </ol>
      </b-container>
      <div>
        <IAMSmartButton  v-if="isMobile && show" @click="iamsmartsign">{{$t("iAmSmartMobileButton")}}</IAMSmartButton>
      </div>      
    </div>
  </div>
</template>

<script>
import { IAMSmartAuthApi, IAMSmartLoginButton, IAMSmartSigningPlainButton, IAMSmartLink, IAMSmartButton } from '@nextore/iam-smart';
import { HubConnectionBuilder } from '@microsoft/signalr';
import { keyBy } from 'lodash';
import { FilesApi, EssSignApi, IAMSmartUserTypeApi, IAmSmartQrCodeApi } from '@/api';

const callbackKeyMixin = {
  created() {
    this._callbackKeys = {};
  },
  methods: {
    addCallbackKey(key) {
      this._callbackKeys[key] = true;
    },
    checkAndRemoveCallbackKey(key) {
      if (this._callbackKeys[key]) {
        delete this._callbackKeys[key];

        return true;
      }

      return false;
    }
  }
};

const signResultMixin = {
  created() {
    const connection = new HubConnectionBuilder()
      .withUrl('/IAmSmart/SignResult')
      .build();

    connection.on('OnSignResult', (businessID, success, message) => {
      if (!this.checkAndRemoveCallbackKey(businessID)) {
        return;
      }

      const file = this.businessIdMap[businessID];

      if (success) {
        file.resolve();
      } else {
        file.reject(
          `Fail to sign document with message ${message}`
        );
      }
    });

    connection
      .start()
      .then(() => {
        this._connection = connection;
      })
      .catch(function (err) {
        this.$dangerToast(
          'Setup iamSmart websocket',
          'Fail to connect iamSmart websocket'
        );

        throw err;
      });
  }
};

export default {
  mixins: [signResultMixin, callbackKeyMixin],
  components: { IAMSmartLoginButton, IAMSmartSigningPlainButton, IAMSmartLink, IAMSmartButton },
  props: {
    value: {}
  },
  data() {
    return {
      loginState: null,
      canSign: false,
      files: [],
      filesMap: {},
      businessIdMap: {},
      show: false,
      iAmSmartUrl: {},
      getIAmSmartUrl: ''
    };
  },
  watch: {
    'value.files': {
      immediate: true,
      async handler(valueFiles) {
        const fileIds = valueFiles.map((file) => file.id);
        const { data: files } = await FilesApi.getFiles(fileIds);

        this.files = files.data.map((file) => ({
          id: file.id,
          name: file.name,
          signCode: null,
          status: 'Pending',
          businessId: null,
          resolve: null,
          reject: null,
          isDrawing: file.propertyValues.fileType == 'Plan',
          isNonPdf: file.name.indexOf('.pdf') > -1 ? false : true,
          message: null
        }));
        this.filesMap = keyBy(this.files, 'id');
      }
    },
    files: {
      deep: true,
      handler(files) {
        const allSigned = files.every((file) => file.status === 'Signed');

        if (allSigned) {
          this.$emit('next');
        }
      }
    }
  },
  async created() {
    await this.acquireAccessToken();
    const getIAmSmartUrl = await IAmSmartQrCodeApi.getIAmSmartUrl();
    this.getIAmSmartUrl = getIAmSmartUrl.data.VUE_APP_IAM_SMART_APP_URL_SCHEME;
  },
  computed: {
    isMobile() {
      let ua = navigator.userAgent;
      let ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
              isIphone = ua.match(/(iPhone\sOS)\s([\d_]+)/),
              isAndroid = ua.match(/(Android)\s+([\d.]+)/),
              isMobile = ipad || isIphone || isAndroid;
      return !!isMobile;
    },
    iAMSmartPlusUrl(){
      if(this.$i18n.locale == "zh_hk"){
        return "https://www.iamsmart.gov.hk/tc/about-version.html"
      }
      else if (this.$i18n.locale == "zh_cn"){
        return "https://www.iamsmart.gov.hk/sc/about-version.html"
      }
      else{
        return "https://www.iamsmart.gov.hk/en/about-version.html"
      }
    }
  },
  mounted() {
    if (this.loginState === 'success') {
      setTimeout(() => {
        this.batchSign();
      }, 0);
    }
  },
  methods: {
    goToIamSmartWebsite() {
      window.location.href = this.iAMSmartPlusUrl;
    },
    async acquireAccessToken() {
      this.loginState = 'checking';

      const { data: hasToken } = await IAMSmartAuthApi.hasAccessToken();
      this.loginState = hasToken ? 'success' : 'fail';

      var userType = await IAMSmartUserTypeApi.getUserType();
      this.canSign = userType.data === 'sign'? true:false;
      // if (hasToken) {
      //   setTimeout(() => {
      //     this.batchSign();
      //   }, 0);
      // }
    },
    async sign(file) {
      var dataFinal = {};
      
      if (file.isDrawing) {
        const { data } = await EssSignApi.digestPdfIAMSmart(file.id);
        dataFinal = data;
      } else if (file.isNonPdf) {
        const { data } = await EssSignApi.digestNonPdfIAMSmart(file.id);
        dataFinal = data;
      } else {
        const { data } = await EssSignApi.digestNormalPdfIAMSmart(file.id);
        dataFinal = data;
      }
      // this.iAmSmartUrl = file.isNonPdf?`${process.env.VUE_APP_IAM_SMART_APP_URL_SCHEME}://hash-sign?ticketID=${dataFinal.ticketID}`:
      // `${process.env.VUE_APP_IAM_SMART_APP_URL_SCHEME}://pdf-sign?ticketID=${dataFinal.ticketID}`;
      this.iAmSmartUrl = file.isNonPdf?`${this.getIAmSmartUrl}://hash-sign?ticketID=${dataFinal.ticketID}`:
      `${this.getIAmSmartUrl}://pdf-sign?ticketID=${dataFinal.ticketID}`;
      file.signCode = dataFinal.signCode;
      file.businessId = dataFinal.businessID;

      this.businessIdMap[file.businessId] = file;

      const prom = new Promise((res, rej) => {
        file.resolve = res;
        file.reject = rej;
      });

      this.addCallbackKey(dataFinal.businessID);
      this._connection.invoke('Listen', dataFinal.businessID);

      await prom;

      file.status = 'Signed';
    },
    async batchSign() {
      this.show = true;
      try {
        for (const file of this.files) {
          await this.sign(file);
        }
      } catch (ex) {
        console.log("ex", ex)
        this.$emit('input', ex.response.data);
        this.$emit('fail');

      throw ex;
    }
    },
    async iamsmartsign() {
      document.location.href = this.iAmSmartUrl;
    }

  },
  i18n: {
    messages: {
      en: {
        docType: 'Document',
        serviceNameLabel: 'Service name:',
        serviceName: 'Electronic Submission Hub (ESH)',
        FailGetIAMSmart: 'Fail to get \"iAM Smart\" session',
        CheckIAMSmart: 'Checking for \"iAM Smart\" session',
        RefreshAfterIAMSmartLogin: 'Please refresh after \"iAM Smart\" login',
        Retry: 'Retry',
        StartSigning: 'Start signing',
        PrepareAccount: 'Please prepare the account of "iAM Smart+" version for signing',
        DocumentName: 'Document Name',
        IdentificationCode: 'Identification Code',
        Signstatus: 'Sign status',
        Retry: 'Retry' ,
        iAmSmartMobileButton: 'Open iAM Smart',
        status: {
          Pending : 'pending',
          Signed : 'Signed'
        },
        tempIamSmartInstrHeader:'Please follow the steps below:',
        IamSmartReminder : 'Your "iAM Smart" account does not provide digital signing function. Please upgrade the account to get digital signing function. For details about upgrade of "iAM Smart" account, please refer to',
        IamSmartWebSite:' the "iAM Smart" website'

      },
      zh_hk: {
        docType: '文件',
        serviceNameLabel: '服務名稱:',
        serviceName: '電子資料呈交及處理系統',
        FailGetIAMSmart: '無法獲取「智方便」部分',
        CheckIAMSmart: '檢查「智方便」部分',
        RefreshAfterIAMSmartLogin: '請在「智方便」登入後刷新',
        Retry: '重試',
        StartSigning: '開始簽署',
        PrepareAccount: '請準備您的「智方便+」帳戶以進行簽名',
        DocumentName: '文件名',
        IdentificationCode: '識別碼',
        Signstatus: '簽署狀態',
        Retry: '重試',
        iAmSmartMobileButton: '開啟智方便',
        status: {
          Pending : '處理中',
          Signed : '已簽署'
        },
        tempIamSmartInstrHeader:'請按照以下步驟:',
        IamSmartReminder:'你的「智方便」戶口未有提供數碼簽署功能 ，請將現在的「智方便」户口升級以獲得數碼簽署功能。有關於升級「智方便」戶口之詳情，請參閱',
        IamSmartWebSite:'「智方便」網站'
      },
      zh_cn: {
        docType: '文件',
        serviceNameLabel: '服务名称:',
        serviceName: '电子资料呈交及处理系统',
        FailGetIAMSmart: '无法获取「智方便」部分',
        CheckIAMSmart: '检查智「智方便」部分',
        RefreshAfterIAMSmartLogin: '请在「智方便」登入后刷新',
        Retry: '重试',
        StartSigning: '开始签署',
        PrepareAccount: '请准备您的「智方便+」帐户以进行签名',
        DocumentName: '文件名',
        IdentificationCode :'识别码',
         Signstatus: '签署状态',
         Retry: '重试',
         iAmSmartMobileButton: '开启智方便',
         status: {
          Pending : '处理中',
          Signed : '已签署'
        },
        tempIamSmartInstrHeader:'请按照以下步骤:',
        IamSmartReminder:'你的「智方便」户口未有提供数码签署功能 ，请将现在的「智方便」户口升级以获得数码签署功能。有关于升级「智方便」户口之详情，請參閱',
        IamSmartWebSite:'「智方便」网站'
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.nx-signing-modal-method-p12 {
  text-align: center;
}
.signCode {
  color: #2b7367;
}
.signFailed{
  color: red
}
</style>
